import { ChangeDetectionStrategy,Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogClose,MatDialogContent, MatDialogRef, MatDialogTitle } from "@angular/material/dialog";
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

export interface AddSubscriptionDialogResult {
    subscriptionLabel: string;
}

@Component({
    selector: 'admin-add-subscription-dialog',
    templateUrl: './add-subscription-dialog.component.html',
    styleUrls: ['./add-subscription-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, MatDialogContent, FormsModule, MatFormField, MatLabel, MatInput, MatDialogActions, MatButton, MatDialogClose]
})
export class AddSubscriptionDialogComponent {
    dialogRef = inject<MatDialogRef<AddSubscriptionDialogComponent>>(MatDialogRef);

    subscriptionInfo: AddSubscriptionDialogResult = {
        subscriptionLabel: '',
    };

    valid() {
        this.dialogRef.close(this.subscriptionInfo);
    }
}
